import gql from "graphql-tag";

export const profilesGQL = gql`
  query Profiles {
    profiles {
      id
      userId
      username
      avatar
      isKidProfile
      locked
      isMainAccount
      isPinProtected
    }
  }
`;
